// Use this function to build a URL for symbols referenced in config.json > SymbolsConfig
export const getSymbolUrl = (id) => {
  const svgFilePath = window.Pin2Flood.SymbolsConfig[id];
  const url = `${window.location.origin}${window.location.pathname}${svgFilePath}`;
  return url;
};
